import RoomInfo from 'types/RoomInfo'
// Dummy Data for test use
export const Rooms: Record<string, RoomInfo> = {
  hall: {
    name: 'Hallway',
    difficulty: 'easy',
    totalHazards: 5,
    missPenalty: 10,
    orderBonus: 10,
    hazards: [
      {
        id: 'bed',
        value: 0, // Value 0 means not a hazard
        title: 'Bed',
        priority: 999,
        path: 'gltfs/Corridor/Hazards/Bed.gltf'
      },
      {
        id: 'bucket',
        value: 100,
        title: 'Mop and bucket',
        priority: 2,
        path: 'gltfs/Corridor/Hazards/Bucket.gltf'
      },
      {
        id: 'equipment',
        value: 1,
        title: 'Equipment',
        priority: 6,
        path: 'gltfs/Corridor/Hazards/Equipment.gltf'
      },
      {
        id: 'machine',
        title: 'Ultrasound machine',
        value: 0, // Value 0 means not a hazard
        priority: 999,
        path: 'gltfs/Corridor/Hazards/Machine.gltf'
      },
      {
        id: 'trolley',
        title: 'Medication trolley',
        value: 10,
        priority: 3,
        path: 'gltfs/Corridor/Hazards/Trolley.gltf'
      },
      {
        id: 'vacuum',
        value: 10,
        title: 'Vacuum',
        priority: 4,
        path: 'gltfs/Corridor/Hazards/Vacuum.gltf'
      },
      {
        id: 'wheelchair',
        value: 5,
        title: 'Wheel chair',
        priority: 5,
        path: 'gltfs/Corridor/Hazards/Wheelchair.gltf'
      },
      {
        id: 'wires',
        value: 200,
        title: 'Wires',
        priority: 1,
        path: 'gltfs/Corridor/Hazards/Wires.gltf'
      }
    ]
  }
}

export default Rooms
